import SecondTabNavigation from "../../../components/organisms/SecondTabNavigation";

const tabConfig = [{ label: "Dashboard", path: "/admin-dashboard" }];

const CustomerSecondNav = () => {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderBottom: "1px solid #e9ecef",
        padding: "0",
      }}
    >
      <SecondTabNavigation tabConfig={tabConfig} />
    </div>
  );
};

export default CustomerSecondNav;
